var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import styles from './GateDeliverablesGateView.module.scss';
import ActionItemsTable from '../Components/ActionItemsTable/ActionItemsTable';
import { ChecklistsTable } from './ChecklistsTable/ChecklistsTable';
import DeliversTable from './DeliversTable/DeliversTable';
import { action, observable } from 'mobx';
import { DocumentView } from '@app/Widgets/DocumentView/DocumentView';
import { observer } from 'mobx-react';
import { AppData, ChecklistSections, GateProcessTypeEnum, ProjectType } from '@app/AppConstants';
import { ProjectStateContext } from '../../Components/ProjectStateContext';
var GateDeliverablesGateView = /** @class */ (function (_super) {
    __extends(GateDeliverablesGateView, _super);
    function GateDeliverablesGateView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isFilesChanged = false;
        _this._documentViewSection = ChecklistSections.Function;
        _this._onDocumentViewCloseHandler = function (isFileChanged) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (isFileChanged) {
                    this._isFilesChanged = !this._isFilesChanged;
                }
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    GateDeliverablesGateView.prototype._handleDocumentClick = function (ciid, section) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._documentViewSection = section;
                this.props.history.push("".concat(this.props.match.url, "/upload/cl-").concat(ciid));
                return [2 /*return*/];
            });
        });
    };
    GateDeliverablesGateView.prototype.render = function () {
        var _this = this;
        var _a = this.props, projectId = _a.projectId, gate = _a.gate, projectState = _a.projectState, projectType = _a.projectType;
        var highlightActionItemId = Number(new URLSearchParams(this.props.location.search).get(AppData.ActionItemQueryParameter)) || undefined;
        var gateProcessType = gate.hasApprovedRecommendation || projectType === ProjectType.Milestone
            ? GateProcessTypeEnum.GateMeeting
            : GateProcessTypeEnum.GateAssessment;
        return (React.createElement(ProjectStateContext.Consumer, null, function (projectStateContext) {
            return (React.createElement(React.Fragment, null,
                React.createElement(ActionItemsTable, { projectId: projectId, gateId: gate.id, gateProcessType: gateProcessType, gateProcessTypeForCreation: gateProcessType, canAdd: gate.canCreateGateAssessmentActionItems || gate.canCreateGateMeetingActionItems, isProjectTerminatedOrCompleted: projectStateContext.isProjectTerminatedOrCompleted, highlightActionItemId: highlightActionItemId }),
                React.createElement("div", { className: styles.subheader }, "Deliverables"),
                React.createElement(DeliversTable, { gateId: gate.id, projectId: projectId, onDocumentIconClick: _this._handleDocumentClick, isFilesChanged: _this._isFilesChanged, projectState: projectState, projectType: projectType, hideNAItems: projectStateContext.hideNAItems, showRedDotDeliverable: projectStateContext.showRedDotDeliverable, isProjectTerminatedOrCompleted: projectStateContext.isProjectTerminatedOrCompleted }),
                React.createElement("div", { className: styles.subheader }, "Checklists"),
                React.createElement(ChecklistsTable, { projectId: projectId, gateId: gate.id, hideNAItems: projectStateContext.hideNAItems, isProjectTerminatedOrCompleted: projectStateContext.isProjectTerminatedOrCompleted }),
                React.createElement(Switch, null,
                    React.createElement(Route, { path: "".concat(_this.props.match.url, "/upload/cl-:id") },
                        React.createElement(DocumentView, { backUrl: _this.props.match.url, section: _this._documentViewSection, onClose: _this._onDocumentViewCloseHandler, isProjectTerminatedOrCompleted: projectStateContext.isProjectTerminatedOrCompleted })))));
        }));
    };
    __decorate([
        observable
    ], GateDeliverablesGateView.prototype, "_isFilesChanged", void 0);
    __decorate([
        action.bound
    ], GateDeliverablesGateView.prototype, "_handleDocumentClick", null);
    __decorate([
        action.bound
    ], GateDeliverablesGateView.prototype, "_onDocumentViewCloseHandler", void 0);
    GateDeliverablesGateView = __decorate([
        observer
    ], GateDeliverablesGateView);
    return GateDeliverablesGateView;
}(React.PureComponent));
export default withRouter(GateDeliverablesGateView);
